import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';

import { theme } from '@/main';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';

import * as React from 'react';
import { useState } from 'react';
import ReactDOM from 'react-dom';
import { ThemeReactComponent } from '@/theme/ThemeReactComponent';

@Component
export class TestSpinner extends ThemeReactComponent {
    @Prop min!: number;
    @Prop max!: number;
    @Prop() value!: number;

    init() {
        log.debug(this.$name, 'Initing');
    }

    render(): JSX.Element {
        const [value, setValue] = useProp(this, 'value');

        const increment = () => {
            setValue(Math.min(value + 1, this.max));
        };
        const decrement = () => {
            setValue(Math.max(value - 1, this.min));
        };

        return (
            <div>
                <button onClick={decrement}>
                    Decrement
                </button>
                <div>
                    {value}
                </div>
                <button onClick={increment}>
                    Increment
                </button>
            </div>
        );
    }
}



